import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './LiveAvailableShiftsActionType';
import * as actions from './LiveAvailableShiftsActions';
import * as services from './LiveAvailableShiftsServices';
import { SweetAlert } from '../../../components/sweetalert/SweetAlert.js';


function* fetchLiveAvailableShiftsSaga(action) {
    try {
        const response = yield call(services.getLiveAvailableShiftsWithPagination, action.payload);
        yield put(actions.fetchLiveAvailableShiftsSuccess(response));
    } catch (error) {
        yield put(actions.fetchLiveAvailableShiftsFailure(error.message));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to fetch Live Available Shifts data',
            showConfirmButton: true
        });
    }
}

function* fetchModalScheduleSaga(action) {
    try {
        const response = yield call(services.getLiveAvailableShiftsWithPagination, action.payload);
        yield put(actions.fetchModalScheduleSuccess(response));
    } catch (error) {
        yield put(actions.fetchModalScheduleFailure(error.message));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to fetch schedule view data',
            showConfirmButton: true
        });
    }
}

function* fetchLegendTableDataSaga() {
    try {
        const response = yield call(services.fetchLegendTableData,);

        if (response?.success) {
            yield put(actions.fetchLegendTableDataSuccess(response));
        } else {
            yield put(actions.fetchLegendTableDataFailure('Failed to fetch legend data'));

            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage
            });
        }
    } catch (error) {
        console.error('Fetch Legend Data Error:', error);

        yield put(actions.fetchLegendTableDataFailure(error?.message || 'Failed to fetch legend data'));

        SweetAlert.error({
            title: 'Error!',
            text: error?.message || 'Failed to fetch legend data.'
        });
    }
}

function* fetchPriorityGroupingLegendSaga() {
    try {
        const response = yield call(services.fetchPriorityGroupingLegend);

        if (response?.success) {
            yield put(actions.fetchPriorityGroupingLegendSuccess(response));
        } else {
            yield put(actions.fetchPriorityGroupingLegendFailure(
                response?.errorMessage || 'Failed to fetch Priority Grouping legend'
            ));
        }
    } catch (error) {
        yield put(actions.fetchPriorityGroupingLegendFailure(
            error?.message || 'Failed to fetch Priority Grouping legend'
        ));
    }
}

function* fetchLiveAvailableShiftsFiltersSaga(action) {
    try {
        const response = yield call(services.fetchLiveAvailableShiftsFilters, action.payload);
        if (response?.success) {
            yield put(actions.fetchLiveAvailableShiftsFiltersSuccess(response));
        } else {
            yield put(actions.fetchLiveAvailableShiftsFiltersFailure(response?.errorMessage));
        }
    } catch (error) {
        yield put(actions.fetchLiveAvailableShiftsFiltersFailure(error?.message));
    }
}

function* fetchLiveAvailableShiftsWorklistSaga(action) {
    try {
        const response = yield call(services.fetchLiveAvailableShiftsWorklists, action.payload);
        if (response?.success) {
            yield put(actions.fetchLiveAvailableShiftsWorklistSuccess(response));
        } else {
            yield put(actions.fetchLiveAvailableShiftsWorklistFailure(response?.errorMessage));
        }
    } catch (error) {
        yield put(actions.fetchLiveAvailableShiftsWorklistFailure(error?.message));
    }
}

function* fetchRadRequestTypeSaga() {
    try {
        const response = yield call(services.fetchRadRequestType);

        if (response?.success) {
            const dropdownItems = response?.values || response?.value || [];
            yield put(actions.fetchRadRequestTypeSuccess(dropdownItems));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to fetch request types';
            yield put(actions.fetchRadRequestTypeFailure(errorMessage));
            SweetAlert.error({
                title: 'Error!',
                text: errorMessage,
            });
        }
    } catch (error) {
        const errorMessage = error?.message || 'Failed to fetch request types';
        yield put(actions.fetchRadRequestTypeFailure(errorMessage));
        SweetAlert.error({
            title: 'Error!',
            text: errorMessage,
        });
    }
}

function* fetchScheduleRecurrenceSaga() {
    try {
        const response = yield call(services.fetchScheduleRecurrence);

        if (response?.success) {
            const dropdownItems = response?.values || response?.value || [];
            yield put(actions.fetchScheduleRecurrenceSuccess(dropdownItems));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to fetch schedule recurrence options';
            yield put(actions.fetchScheduleRecurrenceFailure(errorMessage));
            SweetAlert.error({
                title: 'Error!',
                text: errorMessage,
            });
        }
    } catch (error) {
        const errorMessage = error?.message || 'Failed to fetch schedule recurrence options';
        yield put(actions.fetchScheduleRecurrenceFailure(errorMessage));
        SweetAlert.error({
            title: 'Error!',
            text: errorMessage,
        });
    }
}

function* saveRadRequestSaga(action) {
    try {
        const { data, onSuccess } = action.payload;
        const response = yield call(services.saveRadRequest, data);

        if (response?.success) {
            yield put(actions.saveRadRequestSuccess(response));
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Request submitted successfully.',
            });

            if (typeof onSuccess === 'function') {
                onSuccess(response);
            }
        } else {
            const errorMessage = response?.errorMessage || 'Failed to submit request';
            yield put(actions.saveRadRequestFailure(errorMessage));
            SweetAlert.error({
                title: 'Error!',
                text: errorMessage,
            });
        }
    } catch (error) {
        const errorMessage = error?.message || 'Failed to submit request';
        yield put(actions.saveRadRequestFailure(errorMessage));
        SweetAlert.error({
            title: 'Error!',
            text: errorMessage,
        });
    }
}

function* saveLiveAvailableShiftsFiltersSaga(action) {
    try {
        const { data, onSuccess } = action.payload;
        const response = yield call(services.saveLiveAvailableShiftsFilters, data);

        if (response?.success) {
            yield put(actions.saveLiveAvailableShiftsFiltersSuccess(response));
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Filters saved successfully.',
            });

            if (typeof onSuccess === 'function') {
                onSuccess(response);
            }
        } else {
            const errorMessage = response?.errorMessage || 'Failed to save filters';
            yield put(actions.saveLiveAvailableShiftsFiltersFailure(errorMessage));
            SweetAlert.error({
                title: 'Error!',
                text: errorMessage,
            });
        }
    } catch (error) {
        const errorMessage = error?.message || 'Failed to save filters';
        yield put(actions.saveLiveAvailableShiftsFiltersFailure(errorMessage));
        SweetAlert.error({
            title: 'Error!',
            text: errorMessage,
        });
    }
}

function* watchLiveAvailableShiftsSaga() {
    yield takeLatest(types.FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST, fetchLiveAvailableShiftsSaga);
    yield takeLatest(types.FETCH_MODAL_SCHEDULE_REQUEST, fetchModalScheduleSaga);
    yield takeLatest(types.FETCH_LEGEND_TABLE_DATA_REQUEST, fetchLegendTableDataSaga);
    yield takeLatest(types.FETCH_PRIORITY_GROUPING_LEGEND_REQUEST, fetchPriorityGroupingLegendSaga);
    yield takeLatest(types.FETCH_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST, fetchLiveAvailableShiftsFiltersSaga);
    yield takeLatest(types.FETCH_LIVE_AVAILABLE_SHIFTS_WORKLIST_REQUEST, fetchLiveAvailableShiftsWorklistSaga);
    yield takeLatest(types.FETCH_RAD_REQUEST_TYPE_REQUEST, fetchRadRequestTypeSaga);
    yield takeLatest(types.FETCH_SCHEDULE_RECURRENCE_REQUEST, fetchScheduleRecurrenceSaga);
    yield takeLatest(types.SAVE_RAD_REQUEST_REQUEST, saveRadRequestSaga);
    yield takeLatest(types.SAVE_LIVE_AVAILABLE_SHIFTS_FILTERS_REQUEST, saveLiveAvailableShiftsFiltersSaga);
}

export default watchLiveAvailableShiftsSaga;